import { useMemo, useState } from 'react';
import { useDebounce } from '@common-fe/common-fe';

const MIN_SEARCH_LENGTH = 3;

export const useSingleOrganizationSearch = () => {
  const [searchString, setSearchString] = useState('');
  const search = useDebounce(searchString);

  const searchValue = useMemo(() => {
    if (search.length >= MIN_SEARCH_LENGTH) return search;
    return '';
  }, [search]);

  const isSearchUsed = useMemo(() => !!searchValue, [searchValue]);

  return {
    searchString,
    setSearchString,
    searchValue,
    isSearchUsed,
  };
};

export default useSingleOrganizationSearch;
